import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import LegalLayout from "@/components/LegalLayout";

export default function CGU() {
  return (
    <Layout>
      <LegalLayout title="Conditions générales d'utilisation" testId="cgu-page">
        <h2>1. Objet</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation (« CGU ») régissent l'utilisation de l'application
          Doudou Alert, accessible via le site web et destinée à aider les familles à retrouver les doudous
          (peluches) perdus de leurs enfants. En utilisant Doudou Alert, vous acceptez sans réserve les présentes CGU.
        </p>

        <h2>2. Description du service</h2>
        <p>Doudou Alert permet :</p>
        <ul>
          <li>De créer des fiches descriptives pour les doudous d'une famille ;</li>
          <li>De déclarer un doudou perdu en indiquant sa dernière position connue ;</li>
          <li>De consulter une liste des doudous récemment signalés trouvés (réservée aux familles inscrites) ;</li>
          <li>De recevoir des messages de personnes ayant trouvé un doudou ;</li>
          <li>D'organiser le retour du doudou via un point relais avec préservation de l'anonymat des adresses postales.</li>
        </ul>

        <h2>3. Inscription et compte utilisateur</h2>
        <p>
          La création d'un compte est nécessaire pour gérer ses doudous. L'inscription se fait soit par email
          et mot de passe, soit via la connexion Google. L'utilisateur s'engage à fournir des informations exactes
          et à maintenir la confidentialité de ses identifiants. <strong>Le mot de passe doit comporter au minimum
          6 caractères, dont au moins un chiffre et un caractère spécial</strong>.
        </p>
        <p>
          Les personnes qui trouvent un doudou peuvent contacter la famille <strong>sans créer de compte</strong>,
          à travers un système de jeton anonyme stocké localement sur leur appareil. Un <strong>prénom, un nom de famille
          et une adresse email</strong> leur sont toutefois demandés lors du signalement : seul le prénom est partagé
          publiquement dans le chat. Le nom et l'email sont conservés de manière strictement confidentielle et
          servent exclusivement à : (i) notifier la personne lors d'un nouveau message, (ii) permettre l'identification
          en cas de litige ou de signalement aux autorités compétentes.
        </p>

        <h2>4. Utilisation autorisée</h2>
        <p>L'utilisateur s'engage à :</p>
        <ul>
          <li>N'utiliser le service que dans le but pour lequel il est destiné (retrouver des doudous) ;</li>
          <li>Ne pas publier de contenu illicite, offensant, diffamatoire, à caractère sexuel ou contraire aux bonnes mœurs ;</li>
          <li>Ne pas utiliser le chat pour solliciter des informations personnelles non nécessaires (adresse, numéro de téléphone) ;</li>
          <li>Respecter la dignité, l'anonymat et la sécurité des autres utilisateurs ;</li>
          <li>Ne pas usurper l'identité d'un tiers ni publier de fausses informations.</li>
        </ul>
        <p className="bg-rose-50 border border-rose-200 rounded-2xl p-4 text-sm">
          ⚖️ <strong>Tout manquement aux règles ci-dessus pourra entraîner la suspension immédiate du compte
          ainsi que des <em>poursuites judiciaires</em></strong> au titre du Code pénal (notamment articles 226-1
          et suivants sur la protection de la vie privée, 222-33 sur le harcèlement, 227-23 sur la diffusion de
          contenus à caractère pédopornographique) et du Code civil (responsabilité délictuelle, articles 1240
          et suivants). Les coordonnées des utilisateurs (y compris des personnes ayant signalé un doudou de
          manière anonyme) pourront être communiquées aux autorités compétentes sur réquisition judiciaire.
        </p>

        <h2>5. Chat et anonymat</h2>
        <p>
          Le service de messagerie n'affiche que les <strong>prénoms</strong> des deux parties. Aucune adresse,
          numéro de téléphone ni email n'est révélé à l'autre partie sans démarche volontaire. Pour préserver la
          vie privée lors du retour du doudou, deux options sont possibles : (i) l'envoi par <strong>point relais</strong>
          (Mondial Relay, Colissimo) ou (ii) un <strong>rendez-vous dans un lieu public neutre</strong>
          (parc, café, mairie…). Nous recommandons fortement d'éviter tout rendez-vous à un domicile privé.
        </p>

        <h2>6. Service gratuit et services optionnels payants</h2>
        <p>
          L'ensemble des fonctionnalités essentielles de Doudou Alert (création de fiches, déclaration de perte,
          consultation des doudous trouvés, messagerie) est <strong>gratuit</strong>.
        </p>
        <p>
          L'envoi par <strong>point relais</strong> (Mondial Relay / Colissimo) est un service de transport
          assuré par un tiers, dont le coût est à la charge de la famille destinataire (généralement entre 3 € et
          5 € selon le format). Doudou Alert ne perçoit aucune commission sur ces frais d'envoi.
        </p>
        <p>
          Des services payants additionnels pourront être proposés ultérieurement (par exemple : étiquettes QR Code
          personnalisées) et feront alors l'objet d'une information préalable des utilisateurs.
        </p>

        <h2>7. Responsabilité</h2>
        <p>
          Doudou Alert est un service d'<strong>intermédiation et d'entraide</strong>. Nous ne garantissons pas
          le retour des doudous perdus ni l'exactitude des signalements de tiers. Nous ne sommes pas responsables
          des dommages, pertes, retards ou litiges survenant entre les utilisateurs lors d'un échange de doudou.
          Les utilisateurs sont seuls responsables de leurs échanges et de la véracité des informations qu'ils publient.
        </p>

        <h2>8. Propriété intellectuelle</h2>
        <p>
          Le logo, le nom Doudou Alert, l'interface et les contenus créés par l'éditeur sont protégés. Les photos
          et descriptions publiées par les utilisateurs restent la propriété de leurs auteurs, qui concèdent une
          licence non exclusive d'affichage à Doudou Alert pour les besoins du service.
        </p>

        <h2>9. Résiliation</h2>
        <p>
          L'utilisateur peut supprimer son compte à tout moment depuis son profil ou par demande à
          contact@doudou-alert.fr. L'éditeur se réserve le droit de suspendre un compte en cas de manquement aux CGU.
        </p>

        <h2>10. Modifications</h2>
        <p>
          Les présentes CGU peuvent être modifiées à tout moment. Les utilisateurs seront informés des changements
          substantiels. L'utilisation continue du service après modification vaut acceptation.
        </p>

        <h2>11. Droit applicable</h2>
        <p>
          Les présentes CGU sont soumises au droit français. En cas de litige, et après tentative de résolution
          amiable, les tribunaux français seront seuls compétents.
        </p>

        <p className="text-sm text-stone-500 mt-8">
          Voir aussi : <Link to="/confidentialite">Politique de confidentialité</Link> · <Link to="/mentions-legales">Mentions légales</Link>
        </p>
      </LegalLayout>
    </Layout>
  );
}
